import { useState } from 'react';
import {LanguageCode} from "../../enum";

export const useRoomState = () => {
  const [isMuted, setIsMuted] = useState(true);
  const [isCallEnding, setIsCallEnding] = useState(false);
  const [participants, setParticipants] = useState([]);
  const [otherParticipant, setOtherParticipant] = useState(null);
  const [otherParticipantMuted, setOtherParticipantMuted] = useState(true);
  const [transcriptions, setTranscriptions] = useState([]);
  const [showSettings, setShowSettings] = useState(false);
  const [copiedCode, setCopiedCode] = useState(false);
  const [myChannel, setMyChannel] = useState(null);
  const [isRemoteAudioMuted, setIsRemoteAudioMuted] = useState(false);
  const [settings, setSettings] = useState({
    translate: true,
    diarise: false,
    sourceLang: LanguageCode.ZUL,
    targetLang: LanguageCode.ENG,
  });

  return {
    isMuted, setIsMuted,
    isCallEnding, setIsCallEnding,
    participants, setParticipants,
    otherParticipant, setOtherParticipant,
    otherParticipantMuted, setOtherParticipantMuted,
    transcriptions, setTranscriptions,
    showSettings, setShowSettings,
    copiedCode, setCopiedCode,
    myChannel, setMyChannel,
    isRemoteAudioMuted, setIsRemoteAudioMuted,
    settings, setSettings,
  };
};
